'use client';

import { useSyncExternalStore } from 'react';
import { PwaConfirmSheet } from '@/components/pwa-ui/PwaConfirmSheet';
import {
  getPwaConfirmCurrent,
  resolvePwaConfirm,
  subscribePwaConfirm,
} from '@/lib/pwa-confirm';

function getSnapshot() {
  return getPwaConfirmCurrent();
}

function getServerSnapshot() {
  return null;
}

export function PwaConfirmHost() {
  const request = useSyncExternalStore(subscribePwaConfirm, getSnapshot, getServerSnapshot);
  return (
    <PwaConfirmSheet
      open={!!request}
      request={request}
      onResolve={resolvePwaConfirm}
    />
  );
}
